import { render, staticRenderFns } from "./routeLabel.vue?vue&type=template&id=7228eba0&scoped=true&"
import script from "./routeLabel.vue?vue&type=script&lang=js&"
export * from "./routeLabel.vue?vue&type=script&lang=js&"
import style0 from "./routeLabel.vue?vue&type=style&index=0&id=7228eba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228eba0",
  null
  
)

export default component.exports